import { post, get, handleClientError } from '../lib'
import { getToken } from '../APIServices'
export interface JobQueueResponse {
  arguments: string
  device: any // TODO FIX
  jobType: string
  runType: string
}

export const postManualUpload = async (
  argument: string,
  deviceId: string
): Promise<any> => {
  try {
    const res = await post<JobQueueResponse, JobQueueResponse>({
      path: `/api/v1/jobQueue`,
      body: {
        arguments: argument,
        device: deviceId,
        jobType: "MANUAL_UPLOAD",
        runType: "SERVER"
      }
    })
    return {arguments: res.arguments}
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getDevice = async (id: number) => {
  const token = getToken()
  const res = await fetch(`/api/v1/devices/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }
  return res.json()
}